import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionType, TransactionTypeValue } from '../../../services/transaction.types';
import AutocompleteFilter, { FilterOption } from './AutocompleteFilter';

interface TypeProps {
    types: TransactionType[];
    value?: TransactionTypeValue[];
    onChange: (value: TransactionTypeValue[]) => void;
}

const Type: React.FC<TypeProps> = ({ types = [], value = [], onChange }) => {
    const { t } = useTranslation();
    const options: FilterOption[] = (types || []).map((type) => ({
        id: type.value.toString(),
        label: type.name,
    }));

    // Convert string IDs to TransactionTypeValue for onChange handler
    const handleChange = (stringValues: string[]) => {
        // Convert string values to TransactionTypeValue
        const typedValues = stringValues.map(val => Number(val) as TransactionTypeValue);
        onChange(typedValues);
    };

    // Convert TransactionTypeValue to strings for Autocomplete component
    const stringValues = value.map(v => v.toString());

    return (
        <AutocompleteFilter
            label={t('transactions.filters.type.label')}
            options={options}
            value={stringValues}
            onChange={handleChange}
            placeholder={t('transactions.filters.type.placeholder')}
        />
    );
};

export default Type;
